// src/pages/Register/VerifyOTPPage.tsx
import React, { useState, useRef, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyOTP } from '../../services/authService';
import LoadingIndicator from '../../components/LoadingIndicator';
import Button from '../../components/Button';
import './VerifyOTPPage.css';

const VerifyOTPPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const navigate = useNavigate();

  const [codeDigits, setCodeDigits] = useState<string[]>([
    '',
    '',
    '',
    '',
    '',
    '',
  ]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    if (!email) navigate('/register/email');
  }, [email, navigate]);

  // 1文字入力で次へフォーカス
  const handleChange = (idx: number, val: string) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...codeDigits];
    next[idx] = val;
    setCodeDigits(next);
    if (val && inputsRef.current[idx + 1]) {
      inputsRef.current[idx + 1]!.focus();
    }
  };

  // 6桁揃ったら自動検証
  useEffect(() => {
    if (codeDigits.every((d) => d !== '')) {
      const code = codeDigits.join('');
      (async () => {
        setLoading(true);
        try {
          const res = await verifyOTP({ email, code });
          const token = res.data.token; // 認証完了トークン
          navigate(`/register/complete?token=${encodeURIComponent(token)}`);
        } catch (err: any) {
          setMessage(
            err.response?.data?.detail ||
            'コードが無効です。再送をお願いします。'
          );
          setCodeDigits(['', '', '', '', '', '']);
          inputsRef.current[0]?.focus();
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [codeDigits, email, navigate]);

  return (
    <div className="verify-otp-page">
      <h1>確認コード入力</h1>
      <p>{email} に送信された6桁のコードを入力してください。</p>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification error">{message}</div>}
      <div className="otp-inputs">
        {codeDigits.map((d, i) => (
          <input
            key={i}
            type="text"
            maxLength={1}
            ref={(el) => {
              inputsRef.current[i] = el;
            }}
            value={d}
            onChange={(e) => handleChange(i, e.target.value)}
            title="Enter OTP digit"
            placeholder=""
          />
        ))}
      </div>
      <Button onClick={() => navigate('/register/email')} disabled={loading}>
        メール再送
      </Button>
      <div className="mail-announcement">
        <p>
          ※メールが届かない場合は、迷惑メールフォルダもご確認ください。
        </p>
      </div>
    </div>
  );
};

export default VerifyOTPPage;
